import { forwardRef } from 'react';
import { CardContentContainer } from './styled';
export const CardContent = forwardRef((props, forwardedRef) => {
    const { children, className, disablePadding = false } = props;
    return (<CardContentContainer className={className} ref={forwardedRef} $noPadding={disablePadding}>
      {children}
    </CardContentContainer>);
});
